import type { StateCreator } from 'zustand';
import type {
  PreferencesState,
  SidebarSlice,
} from '../types/preferencesStoreTypes';

export const createSidebarSlice: StateCreator<
  PreferencesState,
  [],
  [],
  SidebarSlice
> = (set) => ({
  isCollapsed: false,
  toggleSidebar: () => set((state) => ({ isCollapsed: !state.isCollapsed })),
  setCollapsed: (collapsed) => set({ isCollapsed: collapsed }),
});
